import React from "react";
import {ProgramDetail} from "../../stores/program/model/Program";
import ProgramDetailPage from "./ProgramDetailPage";
import ProgramOverview from "./ProgramOverview";
import styles from "./ProgramPage.module.css";

export interface ProgramPageProps {
  // チャンネル
  channel: ProgramDetail;
}


function ProgramPageV2({channel}: {
  channel: ProgramDetail;
}) {
    return (
        <div className={styles.container}>
            <ProgramOverview channel={channel}/>
            <ProgramDetailPage
                channel={channel}
            />
        </div>
    );
}

export default ProgramPageV2;
